import { createLink } from "@tanstack/react-router"
import type { ComponentProps } from "react"
import { Button } from "@holigral/shared/ui/components/ui/button"

// nativeButton={false} stops Base UI stamping an invalid type="button" on
// the anchor, but it then merges in role="button", which would cost a real
// navigation link its link semantics. Pin the role back; caller props win
// the merge, so a caller who genuinely wants a button role can still say so.
const ButtonLink = createLink((props: ComponentProps<typeof Button>) => (
  <Button nativeButton={false} role="link" render={<a />} {...props} />
))

export default ButtonLink
